import { AppInvariantError } from '../error';
import isNil from 'lodash-es/isNil';
import isNumber from 'lodash-es/isNumber';

export namespace Invariant {
  export function notNull<T>(val: T | null): T {
    if (val === null) {
      throw new AppInvariantError(`Invariant: value should not be null`);
    }
    return val;
  }

  export function notNil<T>(val: T | null | undefined): T {
    if (isNil(val)) {
      throw new AppInvariantError(`Invariant: value should not be null | undefined`);
    }
    return val;
  }

  export function notUndefined<T>(val: T | undefined): T {
    if (val === undefined) {
      throw new AppInvariantError(`Invariant: value should not be undefined`);
    }
    return val;
  }

  export function number<T>(val: T): number {
    if (!isNumber(val)) {
      throw new AppInvariantError(`Invariant: value should be a number`);
    }
    return val;
  }

  export function stateExist<S extends object, K extends keyof S, T extends S[K]>(
    state: S,
    property: K,
    val: T | undefined
  ): T {
    if (state[property] === undefined) {
      throw new AppInvariantError(`Invariant: missing state ${property}`);
    }
    return state[property] as any;
  }
}

// Aliases
export const nn = Invariant.notNull;
export const nu = Invariant.notUndefined;
export const se = Invariant.stateExist;



// WEBPACK FOOTER //
// ./src/module/Common/utils/Invariant.ts